module.exports = __webpack_public_path__ + "img/ASFT_visualisoinnit_muokatut-06.953bf876.png";